export default __webpack_public_path__ + "assets/images/af5735c195346d58bc2244da9d48678b.png";